import { render } from "./Blogs.vue?vue&type=template&id=1ba650ff&scoped=true"
import script from "./Blogs.vue?vue&type=script&lang=js"
export * from "./Blogs.vue?vue&type=script&lang=js"

import "./Blogs.vue?vue&type=style&index=0&id=1ba650ff&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba650ff"]])

export default __exports__